import type { Database } from "@/lib/supabase";
import { ContactListItem } from "./ContactListItem";
import { isContactUnread } from "@/utils/contactUtils";

type AccountContact = Database["public"]["Tables"]["account_contacts"]["Row"];

interface ContactListProps {
  contacts: AccountContact[];
  selectedContact: AccountContact | null;
  onContactSelect: (contact: AccountContact) => void;
  loading: boolean;
  searchTerm?: string;
}

export const ContactList = ({
  contacts,
  selectedContact,
  onContactSelect,
  loading,
}: ContactListProps) => {
  if (loading) {
    return (
      <div className="flex-1 overflow-y-auto rounded-xl border border-border dark:border-[#3F3F464D] bg-card dark:bg-transparent p-3">
        <div className="flex flex-col gap-3">
          {[1, 2, 3, 4, 5].map((i) => (
            <div key={i} className="flex items-center gap-2 animate-pulse">
              <div className="w-8 h-8 bg-card-muted dark:bg-neutral-600 rounded-full" />
              <div className="flex-1">
                <div className="h-3.5 bg-card-muted dark:bg-neutral-600 rounded mb-1.5" />
                <div className="h-2.5 bg-card-muted dark:bg-neutral-600 rounded w-3/4" />
              </div>
            </div>
          ))}
        </div>
      </div>
    );
  }

  if (contacts.length === 0) {
    return (
      <div className="flex-1 overflow-y-auto rounded-xl border border-border dark:border-[#3F3F464D] bg-card dark:bg-transparent p-4" />
    );
  }

  return (
    <div className="flex-1 overflow-y-auto rounded-xl border border-border dark:border-[#3F3F464D] bg-card dark:bg-transparent hidden md:block">
      {contacts.map((contact) => {
        const isSelected = selectedContact?.id === contact.id;
        const isUnread = !isSelected && isContactUnread(contact);
        return (
          <ContactListItem
            key={contact.id}
            contact={contact}
            isSelected={isSelected}
            isUnread={isUnread}
            onSelect={onContactSelect}
          />
        );
      })}
    </div>
  );
};
